// extracted by mini-css-extract-plugin
var _1 = "aaewiU0AopFFSq2fFnhv";
export { _1 as "shared_heading" }
